import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as PasswordManagerAction from "../../../store/passwordManagerService/actions";
import * as httpClient from "../../../util/httpClient";
import * as Common from "../../../util/common";
import { useTranslation } from "react-i18next";

const PasswordList = (props: any) => {
    const dispatch = useDispatch();
    const requestRequestPasswordList = () => dispatch(PasswordManagerAction.actionCreators.requestRequestPasswordList());
    const { t: tLang } = useTranslation();

    const passwordList = useSelector((state: ApplicationState) => {
        const passwordList = state.passwordManagerState ? state.passwordManagerState.passwordList : [];
        const favouritPasswordList = passwordList.filter((item) => {
            if (props.search) {
                if (props.favourite) {
                    if (item.websiteName && item.websiteName.toLowerCase().includes(props.search) && item.favorite && item.favorite === 1) {
                        return true;
                    }
                } else {
                    if (item.websiteName && item.websiteName.toLowerCase().includes(props.search) && !(item.favorite && item.favorite === 1)) {
                        return true;
                    }
                }
            } else {
                if (props.favourite) {
                    if (item.favorite && item.favorite === 1) {
                        return true;
                    }
                } else {
                    if (!(item.favorite && item.favorite === 1)) {
                        return true;
                    }
                }
            }

            return false;
        });

        favouritPasswordList.sort((item1, item2) => {
            if (item1 && item2 && item1.websiteName && item2.websiteName) {
                var name1 = item1.websiteName.toUpperCase(); // ignore upper and lowercase
                var name2 = item2.websiteName.toUpperCase(); // ignore upper and lowercase
                if (name1 < name2) {
                    return -1;
                }
                if (name1 > name2) {
                    return 1;
                }
            }

            return 0;
        });

        favouritPasswordList.forEach((item) => Common.decodeData(item));

        return favouritPasswordList;
    });

    const openDialogue = (passwordRecordExtId: any) => {
        dispatch(PasswordManagerAction.actionCreators.setPasswordExtId(passwordRecordExtId));
        props.showDialog();
    };

    const toggleFavourite = (recordExtId: any, name: any) => {
        dispatch(PasswordManagerAction.actionCreators.toggleFavourite(recordExtId));

        const requestBody = {
            RecordExtId: recordExtId,
        };

        httpClient
            .sendRequest("POST", `api/securepassword/getPasswordById`, requestBody)
            .then((data) => {
                if (data.isSuccess) {
                    let favorite = true;

                    if (data.favorite) {
                        favorite = false;
                    }

                    const requestData = Common.decodeData(Common.decodeData(data));

                    const requestBody = {
                        favorite: favorite,
                        recordExtId: recordExtId,
                        websiteUsername: requestData.websiteUsername,
                        websitePassword: data.websitePassword,
                        websiteUrl: requestData.websiteUrl,
                        websiteName: requestData.websiteName,
                        notes: requestData.notes,
                    };

                    httpClient
                        .sendRequest("POST", `api/securepassword/updatePassword`, requestBody)
                        .then((data) => {
                            if (data.isSuccess) {
                                requestRequestPasswordList();
                                dispatch(PasswordManagerAction.actionCreators.setPasswordExtId(""));
                            }
                        })
                        .catch(function (error) {});
                }
            })
            .catch(function (error) {});
    };

    return (
        <Fragment>
            {passwordList.length > 0 &&
                passwordList.map((item, index) => {
                    return (
                        <div role="listitem" className="data-row" key={index}>
                            <div className="password-container">
                                <a
                                    href="javascript:void(0);"
                                    data-a11y-dialog-show="dialog-view-password"
                                    onClick={() => openDialogue(item.recordExtId)}
                                    className="password-link"
                                >
                                    <span className="password-text">
                                        <span className="password-title search-term">{item && item.websiteName && item.websiteName}</span>
                                    </span>
                                </a>
                                <div className="password-favourite">
                                    <div
                                        className="form-input"
                                        onClick={() => window.addToDataLayer({ event: props.favourite ? "Make Password Not Favorite" : "Make Password Favorite" })}
                                    >
                                        <label
                                            className="form-favourite-label"
                                            title={
                                                props.favourite
                                                    ? tLang("identityVault.passwordManager.addEditPassword.label.rmvFrmFvtTooltip")
                                                    : tLang("identityVault.passwordManager.addEditPassword.label.mrkAsFvtTooltip")
                                            }
                                            htmlFor={props.favourite ? "mark-fav-pw-favorite-" + (index + 1) : "mark-fav-pw-not-favorite-" + (index + 1)}
                                        >
                                            <input
                                                type="checkbox"
                                                id={props.favourite ? "mark-fav-pw-favorite-" + (index + 1) : "mark-fav-pw-not-favorite-" + (index + 1)}
                                                onChange={() => toggleFavourite(item.recordExtId, item.websiteName)}
                                                checked={item.favorite === 1 ? true : false}
                                            />
                                            <span className="form-favourite-label-text">
                                                <span className="sr-only">
                                                    {props.favourite ? "Unmake " + item.websiteName + " as Favorite" : "Mark " + item.websiteName + " as Favorite"}
                                                </span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
        </Fragment>
    );
};

export default PasswordList;
